import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { UtmParams } from './ya-metric/utm-params.interface';

@Injectable({
  providedIn: 'root'
})
export class MetricService {
  constructor() {
  }

  private _metricEventGoal$: Subject<string> = new Subject<string>();
  metricEventGoal$: Observable<string> = this._metricEventGoal$.asObservable();

  setMetricEventGoal(goal: string): void {
    this._metricEventGoal$.next(goal);
  }

  private _utmParams: BehaviorSubject<UtmParams | null> = new BehaviorSubject<UtmParams | null>(null);
  utmParams$: Observable<UtmParams | null> = this._utmParams.asObservable();

  get utmParams(): UtmParams | null {
    return this._utmParams.getValue();
  }

  setUtmParams(params: UtmParams): void {
    this._utmParams.next(params);
  }
}
